<template>
  <div id="app">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition,
  },
  mounted() {
    this.login();
  },
  methods: {
    login() {
      if (this.$cookies.isKey("engine-token")) return;
      let href = window.location.href;
      window.location.href =
        "https://sso.piesat.cn/sso/login?ReturnUrl=" +
        encodeURIComponent(href) +
        "&clientId=88dbb3bb116d4fadbdea54b9e828b889";
    },
  },
};
</script>
